import { render } from "./DueDateSummary.vue?vue&type=template&id=51f55e0b"
import script from "./DueDateSummary.vue?vue&type=script&lang=js"
export * from "./DueDateSummary.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__